import React from 'react';
import LoginPage from './LoginPage';

export default function Login() {
  return <LoginPage />;
}
